'use client'
import SuperTokensWebJs from 'supertokens-web-js'
import SuperTokensConfig from '../../configs/SuperTokensConfig'

if (typeof window !== 'undefined') {
  SuperTokensWebJs.init(SuperTokensConfig())
}

export const SuperTokensInit = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>
}
